import React from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import {
  CalculateDeviation,
  CheckClientInCensusByClientId,
  CheckClientInCensusDetails,
  GetPlanAvDeviationByClientName,
  UpdateCensus,
  UpdateCensusStage2,
  UpdateCensusStage3,
  UpdateCensusStage4,
  UpdateCensusStage5,
  UpdateCensusStage6,
  UpdatePlanAvDeviation,
} from "../../../../api/User/ACG/planavdeviationApi";
import { useSelector } from "react-redux";
import theme from "../../../../Utils/theme";
// import { ExportCsv } from "@material-table/exporters";
// import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import editIcon from "../../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../../assets/icon/pencil-fill-white.svg";
import { useLocation } from "react-router-dom";
import Required from "../../../../components/Required";
import { downloadCsv } from "../../../../Utils/exportCsv";

const schema = Yup.object().shape({
  intended_Metal_Tier: Yup.string()
    .notOneOf(["Select Intended Metal Tier"], "required")
    .required("required"),
  actual_Plan_AV: Yup.number()
    .typeError("Please enter a valid number")
    .required("required"),
});

const PlanAVDeviation = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const location = useLocation();
  const [data, setData] = useState([]);
  const [isGetData, setIsGetData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const fileName =
    location.pathname.split("/")[location.pathname.split("/").length - 1];

  const column = [
    { title: "Client ID", field: "client_ID" },
    { title: "Plan", field: "plan" },
    { title: "Intended Metal Tier", field: "intended_Metal_Tier" },
    {
      title: "IRMI AV Benchmark",
      field: "metal_Tier_AV",
      render: (rowData) => (+rowData.metal_Tier_AV * 100).toFixed(2) + "%",
      // render: ({intended_Metal_Tier}) => {
      //   if (intended_Metal_Tier === null) return false;
      //   if (intended_Metal_Tier.toLowerCase() === "platinum") return 0.9471;
      //   else if (intended_Metal_Tier.toLowerCase() === "gold") return  0.8524;
      //   else if (intended_Metal_Tier.toLowerCase() === "silver") return  0.7545;
      //   else if (intended_Metal_Tier.toLowerCase() === "bronze") return  0.6723;
      // },
      // customFilterAndSearch: (query, rowData) => {
      //   const searchText = query.toLowerCase();
      //   const processedData = (+rowData.metal_Tier_AV * 100).toFixed(2) + "%";
      //   return processedData.toLowerCase().includes(searchText);
      // },
    },
    {
      title: "Actual Plan AV",
      field: "actual_Plan_AV",
      render: (rowData) => (+rowData.actual_Plan_AV * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.actual_Plan_AV * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "AV Deviation",
      field: "actuarial_Deviation",
      render: (rowData) =>
        (+rowData.actuarial_Deviation * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData =
          (+rowData.actuarial_Deviation * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "Actions",
      minWidth: "74px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) => {
        return rowData?.plan !== "Average Plan AV" &&
          rowData?.plan !== "Blended w Utilization" ? (
          <img
            src={
              selectedRow === rowData.tableData.id ? editIconWhite : editIcon
            }
            width="11"
            className="m-2 cursor-pointer"
            alt="edit icon"
            onClick={() => {
              setSelectedRowData(rowData);
              setShowModal(true);
            }}
          />
        ) : null;
      },
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getData();
  }, [client]);

  const getData = () => {
    setIsLoading(true);
    GetPlanAvDeviationByClientName(client?.clientID)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    const { intended_Metal_Tier, actual_Plan_AV } = values;
    const payload = {
      ...selectedRowData,
      intended_Metal_Tier,
      actual_Plan_AV: +actual_Plan_AV,
    };
    delete payload.tableData;
    UpdatePlanAvDeviation(payload).then((res) => {
      if (res.status === 200 || res.status === 204) {
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
      }
    });
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Update Plan AV & Deviation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              intended_Metal_Tier:
                selectedRowData?.intended_Metal_Tier ??
                "Select Intended Metal Tier",
              actual_Plan_AV: +selectedRowData?.actual_Plan_AV ?? 0,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <Form.Group>
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Intended Metal Tier
                      <Required />
                    </Form.Label>
                    <Form.Select
                      className="rounded-0"
                      style={Fontstyling.label}
                      name="intended_Metal_Tier"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={
                        errors.intended_Metal_Tier &&
                        touched.intended_Metal_Tier
                      }
                    >
                      {[
                        "Select Intended Metal Tier",
                        "Platinum",
                        "Gold",
                        "Silver",
                        "Bronze",
                      ].map((item) => (
                        <option
                          value={item}
                          selected={values.intended_Metal_Tier === item}
                        >
                          {item}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.intended_Metal_Tier}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <CustomInputField
                    label="Actual Plan AV"
                    name="actual_Plan_AV"
                    maxLength={10}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    isRequired
                  />
                </Row>
                <div className="text-end my-4">
                  <CustomButton
                    Ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    Save
                  </CustomButton>
                  <CustomButton
                    style={Fontstyling.cancelbutton}
                    onClick={() => setShowModal(false)}
                    type="button"
                  >
                    Cancel
                  </CustomButton>
                </div>
                <span className="text-success" style={{ fontSize: "12px" }}>
                  * No special characters are allowed
                </span>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title
          // id="contained-modal-title-vcenter"
          // style={Fontstyling.modalHeading}
          >
            Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You are about to override the plan values & Deviation. You will not be
          able to undo this change. Do you wish to proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={async () => {
              await CalculateDeviation(client?.clientID).then((res) => {
                if (res.status === 200 || res.status === 204) {
                  toastFile("calculation true");
                }
              });
              getData();
              setShowConfirmModal(false);
            }}
          >
            Yes
          </Button>
          <Button
            style={{
              ...Fontstyling.cancelbutton,
              marginLeft: "5px",
            }}
            onClick={() => setShowConfirmModal(false)}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex justify-content-end gap-2 align-items-center mt-md-0 mt-3">
        <CustomButton
          className={`py-1 px-2 ${isLoading && "disabled"}`}
          onClick={() => {
            if (
              client === null ||
              client?.clientID === null ||
              client?.clientID === 0
            ) {
              toastFile("Select Client");
            } else {
              setIsLoading(true);
              CheckClientInCensusDetails(client?.clientID)
                .then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    if (res.data === "Null Or 0 Found") {
                      toastFile("calculation false");
                    } else if (res.data === "Client Not Found") {
                      toastFile(
                        "Census for this client does not exist in the system. Please import Census and Then try again",
                        "error"
                      );
                    } else {
                      setShowConfirmModal(true);
                    }
                  }
                })
                .finally((res) => setIsLoading(false));
            }
          }}
        >
          Calculate Deviation
        </CustomButton>
        <CustomButton
          className={`py-1 px-2 ${isLoading && "disabled"}`}
          style={{
            ...Fontstyling.addnewbutton,
            background: theme.SECONDARY_CHEERFUL_GOLD,
          }}
          onClick={async () => {
            if (
              client === null ||
              client?.clientID === null ||
              client?.clientID === 0
            ) {
              toastFile("Select Client");
            } else {
              setIsLoading(true);
              CheckClientInCensusByClientId(client?.clientID).then(
                async (res) => {
                  if (res.status === 200 || res.status === 204) {
                    if (res.data === "plan not found") {
                      setIsLoading(false);
                      toastFile(res.data);
                    } else if (res.data === "client not found") {
                      setIsLoading(false);
                      toastFile(
                        "Please import census first and then try again"
                      );
                    } else {
                      await UpdateCensus(client?.clientID, 1, user.UD_id).then(
                        (res) => {
                          if (res.data === "stage1") {
                            UpdateCensusStage2(
                              client?.clientID,
                              2,
                              user.UD_id
                            ).then((res) => {
                              if (res.data === "stage2") {
                                UpdateCensusStage3(
                                  client?.clientID,
                                  3,
                                  user.UD_id
                                ).then((res) => {
                                  if (res.data === "stage3") {
                                    UpdateCensusStage4(
                                      client?.clientID,
                                      4,
                                      user.UD_id
                                    ).then((res) => {
                                      if (res.data === "stage4") {
                                        UpdateCensusStage5(
                                          client?.clientID,
                                          5,
                                          user.UD_id
                                        ).then((res) => {
                                          if (res.data === "stage5") {
                                            UpdateCensusStage6(
                                              client?.clientID,
                                              6,
                                              user.UD_id
                                            ).then((res) => {
                                              if (res.data === "stage6") {
                                                getData();
                                                toastFile("update");
                                              } else {
                                                toastFile(
                                                  "Something went wrong."
                                                );
                                              }
                                              setIsLoading(false);
                                            });
                                          } else {
                                            setIsLoading(false);
                                            toastFile("Something went wrong.");
                                          }
                                        });
                                      } else {
                                        setIsLoading(false);
                                        toastFile("Something went wrong.");
                                      }
                                    });
                                  } else {
                                    setIsLoading(false);
                                    toastFile("Something went wrong.");
                                  }
                                });
                              } else {
                                setIsLoading(false);
                                toastFile("Something went wrong.");
                              }
                            });
                          } else {
                            setIsLoading(false);
                            toastFile("Something went wrong.");
                          }
                        }
                      );
                      // await UpdateCensus(client?.clientID, 1, user.UD_id);
                      // await UpdateCensusStage2(client?.clientID, 2, user.UD_id);
                      // await UpdateCensusStage3(client?.clientID, 3);
                      // await UpdateCensusStage4(client?.clientID, 4);
                      // await UpdateCensusStage5(client?.clientID, 5);
                      // await UpdateCensusStage6(client?.clientID, 6).then(
                      //   (res) => {
                      //     toastFile("update");
                      //   }
                      // );
                    }
                  }
                }
              );
            }
          }}
        >
          Recalibrate Census Data
        </CustomButton>
      </div>
      <MaterialTable
        columns={column}
        data={data}
        isLoading={isLoading}
        icons={{
          Export: () => (
            <div
              onClick={(e) => {
                //ExportCsv(column, data, fileName);
                downloadCsv(column, data, fileName);
                e.stopPropagation();
              }}
            >
              <CustomButton className="px-3 fw-bold text-nowrap d-flex align-items-center">
                <SaveAltIcon className="me-2" />
                Export to CSV
              </CustomButton>
            </div>
          ),
        }}
        onRowClick={(event, rowData) => {
          if (rowData.tableData.id === selectedRow) setSelectedRow(null);
          else setSelectedRow(rowData.tableData.id);
        }}
        options={{
          exportAllData: true,
          sorting: false,
          draggable: false,
          actionsColumnIndex: -1,
          pageSize: 10,
          paging: data.length > 10,
          paginationType: "normal",
          search: true,
          filtering: false,
          showTitle: false,
          toolbar: true,
          toolbarButtonAlignment: "left",
          exportButton: data.length > 10,
          exportFileName: fileName,
          // exportMenu: [
          //   // {
          //   //   label: "Export PDF",
          //   //   exportFunc: (cols, datas) => ExportPdf(cols, datas, fileName),
          //   // },
          //   {
          //     label: "Export CSV",
          //     exportFunc: (cols, datas) => ExportCsv(cols, datas, fileName),
          //   },
          // ],
          rowStyle: (rowData) => {
            const index = rowData.tableData.id;

            if (index === selectedRow) {
              return {
                padding: "0px",
                height: "40px",
                fontSize: "11px",
                fontFamily: "Arial",
                border: "1px solid #dee2e6",
                textAlign: "start",
                color: "white",
                backgroundColor: "#999999",
                fontWeight:
                  rowData?.plan === "Average Plan AV" ||
                  rowData?.plan === "Blended w Utilization"
                    ? "700"
                    : "normal",
              };
            }
            return {
              padding: "0px",
              height: "40px",
              fontSize: "11px",
              fontFamily: "Arial",
              border: "1px solid #dee2e6",
              textAlign: "start",
              fontWeight:
                rowData?.plan === "Average Plan AV" ||
                rowData?.plan === "Blended w Utilization"
                  ? "700"
                  : "normal",
            };
          },
          headerStyle: {
            padding: "0px",
            zIndex: 0,
            backgroundColor: "#18252D",
            color: "#EEF0E2",
            textTransform: "capitalize",
            fontSize: "11px",
            fontFamily: "Arial",
            fontWeight: "700",
            border: "1px solid #dee2e6",
          },
          actionsCellStyle: {
            padding: "0px",
            maxWidth: "20px",
          },
        }}
      />
    </div>
  );
};

export default PlanAVDeviation;
